import * as yup from 'yup';
import useValidators from 'components/Form/validations/useValidators';

const useValidationSchema = () => {
  const { required } = useValidators();

  const FormSchema = yup.object().shape({
    name: required(yup.string()),
    mdexNodeUuid: yup.string().nullable(),
  });

  return { FormSchema };
};

export default useValidationSchema;
